import DOMPurify from 'dompurify';

interface HtmlContentCustomProps {
    html: string;
}

export default function TmpHtmlContentCustom(props: HtmlContentCustomProps) {

    // Limpar o HTML com DOMPurify para prevenir ataques XSS
    const cleanHtml = DOMPurify.sanitize(props.html);

    return (
        <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
    );

}